/**
 * Utility functions for cleaning and formatting policy titles and icons.
 */

export function cleanPolicyTitle(rawTitle: string, policyId?: string): string {
  if (!rawTitle && !policyId) return 'Policy Document';

  let text = (rawTitle || policyId || '')
    .replace(/\|.*$/g, '') // remove '| Discord', '| Microsoft Legal'
    .replace(/- GitHub Docs/gi, '')
    .replace(/\\ Anthropic/gi, '')
    .replace(/– Privacy & Terms – Google/gi, '')
    .replace(/Policy Explainer/gi, 'Policy')
    .replace(/Terms and Conditions of Use/gi, 'Terms of Use')
    .replace(/General Privacy Statement/gi, 'Privacy Policy')
    .replace(/Privacy Statement/gi, 'Privacy Policy')
    .replace(/Privacy Notice/gi, 'Privacy Policy')
    .replace(/Website Terms of Use/gi, 'Terms of Use')
    .replace(/Paid Services Terms/gi, 'Terms of Service')
    .replace(/Commercial Terms of Service/gi, 'Commercial Terms')
    .replace(/Read Our Business Standards/gi, 'Business Standards')
    .replace(/How Google uses cookies/gi, 'Cookie Policy')
    .replace(/How to Report Abusive Behavior To Discord/gi, 'Abuse Reporting Policy')
    .trim();

  // If still ugly or empty, derive from slug
  if (!text || text.length < 3 || text.startsWith('http')) {
    if (policyId) {
      text = policyId.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
    }
  }

  // Cap length
  if (text.length > 32) {
    text = text.substring(0, 30) + '...';
  }

  return text;
}
